define('models/pages/organization/index',['require','models/base/model','models/pages/organization/settings','models/pages/organization/users','models/pages/organization/markers'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        OrganizationSettings = require('models/pages/organization/settings'),
        OrganizationUsers = require('models/pages/organization/users'),
        OrganizationMarkers = require('models/pages/organization/markers');

    var OrganizationPage = Model.extend({
        defaults: {
            haveMarkers: false
        },
        constructor: function() {
            this.settings = new OrganizationSettings();
            this.users = new OrganizationUsers();
            this.markers = new OrganizationMarkers();
            Model.apply(this, arguments);
        },
        parse: function(data){
            this.settings.set(data.organization);
            this.settings.set('currency', data.currency);
            this.users.set(data.users);
            return data;
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.users.dispose();
            this.settings.dispose();
            this.markers.dispose();
            Model.prototype.dispose.apply(this, arguments);
        },
        load: function(a) {
            this[this.get('page')].load(a);
        }
    });

    return OrganizationPage;
});
